/**
 * TTSAlertMounter — passive global mount-point for `useTTSAlert`.
 *
 * Story 1.9.1. Renderizado dentro do layout autenticado (App.tsx, dentro
 * de NotificationProvider/BrandingProvider) pra garantir que o hook fique
 * vivo em todas as rotas protegidas, sem montar nada visual.
 *
 * Não tem props nem state visível. Sair daqui = perder TTS de alertas P0
 * até remontar.
 */
import { useTTSAlert } from "@/hooks/useTTSAlert";

export function TTSAlertMounter(): null {
  useTTSAlert();
  return null;
}

export default TTSAlertMounter;
